module.exports = __webpack_public_path__ + "static/media/amazon.d33c4b23.png";